<template>
  <section id="registration" class="reg">
    <div class="card-alt mt-0">
      <div class="card-alt-body">
        <!-- <div class="page-header">
          <div class="row justify-content-end">
            <div class="col-10 text-left">
              <h2 class="page-title">{{tabName}}</h2>
            </div>
            <div class="col-2 lighten text-right">
              <h2 class="page-title">{{percentage}}%</h2>
            </div>
          </div>
        </div> -->
        <router-view >
        </router-view>
          
        <!-- <form-wizard :finish-button-text="$t('button.Finish')" shape="tab" color="#4885ed" @on-complete="onComplete" @on-change="onChange" ref="wizard">
          <tab-content title="IT Certification" icon="mdi mdi-book" :before-change="beforeCertificateTabSwitch">
            
            <it-certification @nextTab="nextTab" ref="certificate" v-if="currentTab == 'IT Certification'"></it-certification>
          </tab-content>
          <tab-content class="animate" title="Personal details" icon="mdi mdi-account" :before-change="beforePersonalTabSwitch">
          
             <personal-details  @nextTab="nextTab" ref="personalDetails" v-if="currentTab == 'Personal details'"></personal-details>
         
           </tab-content>
          <tab-content class="animate" title="Contact Details" icon="mdi mdi-account-location" :before-change="beforeContactTabSwitch">
          
             <candidate-address  @nextTab="nextTab" ref="address" v-if="currentTab == 'Contact Details'"></candidate-address>
         
           </tab-content>
          <tab-content class="animate" title="Educational Details" icon="mdi mdi-school" :before-change="beforeEducationTabSwitch">
         
             <educational-details   @nextTab="nextTab" ref="education" v-if="currentTab == 'Educational Details'"></educational-details>
        
           </tab-content>
        
          <tab-content class="animate" title="Documents Upload" icon="mdi mdi-book-multiple-variant" :before-change="beforeDocUploadTabSwitch">
            <documentsuploader  @nextTab="nextTab" ref="document" v-if="currentTab == 'Documents Upload'"></documentsuploader>
          </tab-content>
           <tab-content title="Image Extracter" icon="mdi mdi-book-multiple-variant" :before-change="beforeImageExtractorTabSwitch">
            <imageExtracter   @nextTab="nextTab" ref="imageExtractor" v-if="currentTab == 'Image Extracter'"></imageExtracter>
          </tab-content>
          <tab-content title="Profile Summary" icon="mdi mdi-library-books" :before-change="beforeSummaryTabSwitch">
            <profile-summary   @nextTab="nextTab" ref="summary" v-if="currentTab == 'Profile Summary'"></profile-summary>
          </tab-content>
        </form-wizard> -->
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import itCertification from './itCertification.vue'
import personalDetails from './personalDetails.vue'
import candidateAddress from './address.vue'
import educationalDetails from './educationalDetails.vue'
import profileSummary from './profileSummary.vue'
import imageExtracter from './imageExtracter.vue'

export default {
  name: 'Registraiton',
  components: {
    FormWizard,
    TabContent,
    itCertification,
    personalDetails,
    candidateAddress,
    educationalDetails,
    imageExtracter,
    documentsuploader: () => import('./documentsupload.vue'),
    profileSummary
  },
  data () {
    return {
      selected: '',
      loadPersonal: false,
      loadContact: false,
      loadEducation: false,
      loadProfile: false,
      loadDoc: false,
      loadImageExtracter: false,
      tabName: '',
      currentTab: '',
      totalTabs: 6,
      percentage: 0,
      counter: 0
    }
  },
  methods: {
    setLoading: function (isValid, tabIndex) {
      console.log('Tab: ' + tabIndex + ' valid: ' + isValid)
    },
    nextTab (val1, val2) {
      this.$refs.wizard.changeTab(val1, val2)
    },
    onComplete: function () {
      var self = this
      axios.post('r/candidateProfile/confirmProfile/' + this.$store.state.candidateProfile.profileUser)
        .then(response => {
          if (response.status === 200) {
            this.$toasted.success(self.$t('toastr.toastrProfileCompleted'), {
              theme: 'bubble',
              duration: this.TOASTR_TIME
            })
            this.$router.push({ name: 'candidateApplication' })
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    onChange: function (val1, val2) {
      /* if (val2 !== 1) {
        this.$refs.personalDetails.scanAadhar = false
      } */
      if (val2 === 1) {
        this.loadPersonal = true
        this.loadDoc = false
        this.tabName = this.$t('registration.tabs.tabPersonalDetails')
        this.currentTab = 'Personal details'
      } else if (val2 === 2) {
        this.loadContact = true
        this.loadDoc = false
        this.tabName = this.$t('registration.tabs.tabContactDetails')
        this.currentTab = 'Contact Details'
      } else if (val2 === 3) {
        this.loadEducation = true
        this.loadDoc = false
        this.tabName = this.$t('registration.tabs.tabEducationDetails')
        this.currentTab = 'Educational Details'
      } else if (val2 === 4) {
        this.loadDoc = true
        this.tabName = this.$t('registration.tabs.tabDocumentUpload')
        this.currentTab = 'Documents Upload'
      } else if (val2 === 6) {
        this.loadProfile = true
        this.loadDoc = false
        this.tabName = this.$t('registration.tabs.tabProfileSummary')
        this.currentTab = 'Profile Summary'
      } else if (val2 === 0) {
        this.tabName = this.$t('registration.tabs.tabITLiteracy')
        this.currentTab = 'IT Certification'
        this.loadDoc = false
      } else if (val2 === 5) {
        this.loadImageExtracter = true
        this.loadDoc = false
        this.tabName = this.$t('registration.tabs.tabImageExtractor')
        this.currentTab = 'Image Extracter'
      }
      if (val1 < val2 && this.percentage < 100) {
        this.counter ++
      } else {
        this.counter --
      }
      this.percentage = (this.counter / this.totalTabs) * 100
      let precision = Math.pow(10, 0)
      this.percentage = Math.ceil(this.percentage * precision) / precision
    },
    beforeCertificateTabSwitch: function () {
      return this.$refs.certificate.validateLearnerCode('form-1')
    },
    beforePersonalTabSwitch: function () {
      return this.$refs.personalDetails.checkAadhaarValidity('form-1')
    },
    beforeContactTabSwitch: function () {
      return this.$refs.address.validateInput('Contactform')
    },
    beforeImageExtractorTabSwitch: function () {
      return this.$refs.imageExtractor.save('form-1')
    },
    beforeEducationTabSwitch: function () {
      return this.$refs.education.saveDetails('educationForm')
    },
    beforeDocUploadTabSwitch: function () {
      return this.$refs.document.documentStatus()
    },
    beforeSummaryTabSwitch: function () {
      return true
    }
  },
  created: function () {
    this.tabName = this.$t('registration.tabs.tabITLiteracy')
    this.currentTab = 'IT Certification'
  }
}
</script>

<style lang="scss">
 
.reg {

  .vue-form-wizard {
    transition: all 1.5s ease !important;
    .wizard-tab-content{
      transition: all 5s ease-in-out !important;
      padding: 50px 15px 10px;
    }
    // .wizard-navigation{}
    .wizard-tab-container{
       transition: all 1s ease-in-out !important;
    }
    .wizard-icon-circle.tab_shape {
      height: 0px;
      outline: none;
      box-shadow: none;
    }
    .wizard-header {
      display: none;
    }
    .wizard-nav-pills {
      & > li.active > a .wizard-icon {
        font-size: 32px;
      }
      .stepTitle {
        font-weight: 400;
        // margin-top: 10px;
        font-size: 14px;
        text-transform: capitalize;
      }
      & > li {
        display: none;
      }
    }
    .wizard-btn {
      color: white;
      // background: #6eb51e;
      border-radius: 40px;
      padding: 12px 10px;
      font-size: 12px;
      font-weight: 500;
      text-transform: uppercase;
      transition: all 0.2s;
      &:hover {
        box-shadow: 1px 3px 15px rgba(0, 0, 0, 0.2);
      }
    }
  }
  .help {
    font-size: 13px;
    word-spacing: 1px;
    padding-left: 12px;
  }
  .red {
    color: #ec4343;
  }
  .v-select {
    display: inline-block;
    font-size: 18px;
    font-weight: 600;
    .input[type='search'] {
      font-size: 18px;
      font-weight: 600;
    }
    .dropdown-toggle {
      z-index: 3;
      font-weight: 600;
      border-left: 0px;
      border-right: 0px;
      border-top: 0px;
      padding-left: 0px;
      border-radius: 0px;
      font-family: 'Open Sans';
      border-color: #e1e1e1;
      .clear {
        line-height: 20px;
      }
    }
    .d-error {
      border-bottom: 1px solid #dd5764 !important;
    }
    .dropdown-menu {
      z-index: 3;
      // box-shadow: none;
      font-family: 'Open Sans';
      border-radius: 5px;
      font-size: 14px;
      font-weight: 600;
      border: none;
      box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);
    }
    .selected-tag {
      color: #495057;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0.25px;
    }
  }
  .card-alt {
    // margin:0px;
    padding: 40px;
    min-height: 600px;
    margin-bottom:80px;
    // box-shadow: none;
  }
  .card-alt-body {
    padding-top: 0px;
  }
  .card-alt-header {
    padding-left: 15px;
    padding-top: 40px;
    padding-bottom: 10px;
  }
  .lighten {
    h2 {
      color: lighten(#495057, 30%);
    }
  }
  form {
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .para {
    display: inline-block;
    margin-bottom: 15px;
    padding-left: 10px;
    font-size: 14px;
  }
  .custom-input {
    z-index: 2;
    display: inline-block;
    color: #495057;
    input::placeholder {
      /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: lighten(#495057, 45%);
      // font-weight:500;
      opacity: 1; /* Firefox */
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: lighten(#495057, 45%);
    }

    ::-ms-input-placeholder {
      /* Microsoft Edge */
      color: lighten(#495057, 45%);
    }

    // border:0px solid #e1e1e1;
    padding: 5px 0;
    margin-bottom: 0;
    label {
      font-size: 11px;
      color: #777;
      text-transform: uppercase;
      margin-bottom: 0;
      padding-left: 10px;
    }

    // .form-default{
    //      border-bottom:1px solid #e1e1e1;
    // }
    .form-control-alt {
      // border:none;
      //  border-color: #eee;
      // padding-left: 10px;
      color: #495057;
      // margin-left: 5px;
      display: inline-block;
      min-width: auto;
      box-shadow: none;
      padding: 10px;
      border-radius: 0px;
      border-bottom: 1px solid #e1e1e1;
      border-top: 0px;
      border-left: 0px;
      border-right: 0px;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0.25px;
      outline: none;
      &:focus {
        box-shadow: none;
        // font-size: 18px;
        // border-color: lighten(#6eb51e, 20%);
      }
      &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
           font-size: 14px;
      }
      &::-moz-placeholder { /* Firefox 19+ */
          font-size: 14px;
      }
      
    }
    .instruct {
      font-size: 12px;
      padding-left: 10px;
      span {
        display: inline-block;
      }
    }
  }
  .upload-pic {
    margin-left: -5px;
    z-index: 1;
    .picture-preview {
      border-radius: 5px;
    }
    .picture-inner {
      border: none;
    }
  }

  .btn-action {
    padding-top: 30px;
  }
  .custom-hr {
    margin-left: 15px;
    margin-right: 15px;
    margin-bottom: 5px;
  }
  .two-col {
    padding-left: 15px;
    padding-right: 15px;
  }
  /* The c-wrap */
  .wrap-cb{
    label{
    //     display: inline-block;
    // margin-bottom: 15px;
    // padding-left: 10px;
    font-size: 14px;
    text-transform: none;
    font-family: "Roboto", sans-serif;
    color: #37474f;
    }
.c-wrap {
    display: inline-block;
    position: relative;
    padding-left: 15px;
    padding-right: 15px;
    // margin-bottom: 12px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Hide the browser's default checkbox */
.c-wrap input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* Create a custom checkbox */
.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #e0e0e0;
}

/* On mouse-over, add a grey background color */
.c-wrap:hover input ~ .checkmark {
    background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.c-wrap input:checked ~ .checkmark {
    background-color: rgb(72, 133, 237);
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */
.c-wrap input:checked ~ .checkmark:after {
    display: block;
}

/* Style the checkmark/indicator */
.c-wrap .checkmark:after {
    left: 10px;
    top: 7px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}}

.v-select input[type=search], .v-select input[type=search]:focus{
  font-size:16px; 
}
}
</style>



// WEBPACK FOOTER //
// src/components/registration/registration.vue